import {
  ChangeDetectionStrategy,
  Component, ContentChild,
  Input,
  OnChanges, SimpleChanges,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { Carousel, CarouselModule, CarouselResponsiveOptions } from 'primeng/carousel';
import { DirectivesModule } from '@shared/directives/directives.module';
import { PipeModule } from '@shared/pipe/pipe.module';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-carousel',
  standalone: true,
  imports: [
    CarouselModule,
    DirectivesModule,
    CommonModule,
    PipeModule
  ],
  templateUrl: './carousel.component.html',
  styleUrl: './carousel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CarouselComponent implements OnChanges {
  @ViewChild(Carousel, { static: false }) pCarousel: Carousel;
  // Reference to the <ng-template> provided by the parent component for pTemplate="item"
  @ContentChild(TemplateRef) slideTemplate!: TemplateRef<{ $implicit: unknown }>;
  @Input() slides: unknown[];
  slidesOnScreenDefault: number = 5;
  /**
   * max slides on screen depends on screen resolution
   */
  responsiveOptions: CarouselResponsiveOptions[] = [
    {
      breakpoint: '925px',
      numVisible: 5,
      numScroll: 1
    },
    {
      breakpoint: '675px',
      numVisible: 5,
      numScroll: 1
    },
    {
      breakpoint: '530px',
      numVisible: 4,
      numScroll: 1
    },
    {
      breakpoint: '425px',
      numVisible: 3,
      numScroll: 1
    }
  ];

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.pCarousel) {
      this.resetPosition();
      // it has own cd to update
      this.pCarousel.cd.markForCheck();
    }
  }

  /**
   * carousel sometimes has unpredicted behaviour and can move carousel position badly after the slide addition
   * to prevent this we should reset position after each slide addition
   */
  resetPosition(): void {
    this.pCarousel.page = 0;
  }
}
